export default function sort(items, key, invertedOrder) {
  const orderValueA = invertedOrder ? -1 : 1;
  const orderValueB = -1 * orderValueA;

  return items.sort((a, b) =>
    a[key] > b[key] ? orderValueA : a[key] === b[key] ? 0 : orderValueB
  );
}
